import React from "react";
import { connect } from "react-redux";
import {
  Button,
  CssBaseline,
  Paper,
  Typography,
  Container,
  withStyles,
  Box,
} from "@material-ui/core";
import { NavLink as RouterLink } from "react-router-dom";
import { Helmet } from "react-helmet";
import { DynamicFormActions } from "../../redux/actions/DynamicFormAction";
import DynamiceRecordList from "./DynamiceRecordList";

const useStyles = (theme) => ({
  paper: {
    marginTop: theme.spacing(2),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    transition: "box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
    backgroundColor: "#fff",
    //padding: theme.spacing(2),
  },
  avatar: {
    margin: theme.spacing(3),
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    margin: theme.spacing(3,0,2,0),
  },
  buttons: {
    display: "flex",
    justifyContent: "flex-end",
  },
  button: {
    marginTop: theme.spacing(1),
  },
  divider: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
  },
});

class DynamicFormList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dynamicFormList: [],
    };
  }

  componentDidMount() {
    this.props.getAll();
  }

  render() {
    const classes = this.props.classes;
    return (
      <>
        <Helmet>
          <title>RxRapidMad | Dynamic Form</title>
        </Helmet>

        <Container component="main" fixed className={classes.main}>
          <CssBaseline />
          <form className={classes.form} noValidate>
            <Box display="flex" >
              <Box flexGrow={1}>
                <Typography
                  gutterBottom
                  variant="h4"
                  color="primary"
                  className={classes.typography}
                >
                  {"Dynamic Form Details"}
                </Typography>
              </Box>
              <Box>
                <Button
                  component={RouterLink}
                  variant="button"
                  variant="contained"
                  color="primary"
                  href="#contained-buttons"
                  to="/admin/dynamicform/new"
                >
                  Add Form
                </Button>
              </Box>
            </Box>
          </form>
          
            <DynamiceRecordList
              formlist={this.props.allFormList ? this.props.allFormList : []}
            ></DynamiceRecordList>
          
        </Container>
      </>
    );
  }
}

function mapStateToProps(state) {
  const allFormList = state.dynamicform.all;
  return { allFormList };
}

const mapDispatchToProps = (dispatch) => {
  return {
    getAll: () => dispatch(DynamicFormActions.getALLDynamicFormRequest()),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles, { withTheme: true })(DynamicFormList));
